module.exports = __webpack_public_path__ + "static/media/5.4c5aefe2.jpg";